import $ from 'cash-dom';
import PpcFilter from './filter/PpcFilter';

let instance = null;

class StartupPrequel {
	constructor() {
		if (!instance) {
			this._$startupPrequel = $('#startup_prequel');

			this._$currentIndex = 1;

			this._$stepsCount = $('#startup_prequel .qa-block').length;

			if ($("#startup_prequel .qa-block.qa-final")) {
				this._$stepsCount--;
			}

			instance = this;
		}

		return instance;
	}

	static getInstance() {
		if (!StartupPrequel._instance) {
			StartupPrequel._instance = new StartupPrequel();
		}

		return StartupPrequel._instance;
	}

	init() {
		let self = this;

		if (!self._$startupPrequel.length) {
			return;
		}

		this._recalcProgress();

		$('#startup_prequel .answer').on('click', (e) => {
			self._$currentIndex++;

			let filterName = $(e.currentTarget).attr('data-filter-name'),
				filterValue = $(e.currentTarget).attr('data-filter-value');

			if (filterName && filterValue) {
				PpcFilter.getInstance().setIsPrequal(true).setValue({filterName, filterValue});
			}

			self._showCurrentQaBlock();
		});

		$('#startup_prequel .back-btn').on('click', (e) => {
			if (self._$currentIndex > 1) {
				self._$currentIndex--;

				self._showCurrentQaBlock();
			}
		});
	}

	_showCurrentQaBlock() {
		let currentQaBlock = $('#startup_prequel .qa-block.qa-' + this._$currentIndex);

		$('#startup_prequel .qa-block.active').removeClass('active');

		if (currentQaBlock.length) {
			currentQaBlock.addClass('active');
		} else if (this._$currentIndex < 1) {
			$('#startup_prequel .qa-block.qa-1').addClass('active');
			this._$currentIndex = 1;
		} else {
			$('#startup_prequel .qa-block.qa-final').addClass('active');

			$('#startup_prequel .progress-holder .progress-text').addClass('hidden');
			$('#startup_prequel .progress-holder .progress-text-final').removeClass('hidden');

			if ($('.vendors-logos')) {
				$('.vendors-logos').remove();
			}

			setTimeout(() => {
				$('#startup_prequel').remove();
				$('body').removeClass('with-startup-prequel');
				$('.hidden-by-startup-prequel').removeClass('hidden-by-startup-prequel');
			}, 1500);
		}

		this._recalcProgress();
	}

	_recalcProgress() {
		$('#startup_prequel .progress-holder .step-count').html(this._$currentIndex);

		let progressWidth = this._$stepsCount && this._$currentIndex >= 1 ?
			Math.ceil((100 / this._$stepsCount) * this._$currentIndex) :
			0;

		if (progressWidth > 100) {
			progressWidth = 100;
		}

		$('#startup_prequel .progress-holder .progress-bar-inner').css({'width': progressWidth + '%'});
	}
}

export default StartupPrequel;
